type MaintenanceMessageTone = 'friendly' | 'geek';
export type MaintenanceMessageContext = 'global' | 'hub';

type MaintenanceMessage = {
  tone: MaintenanceMessageTone;
  text: string;
  contexts?: readonly MaintenanceMessageContext[];
};

export const MAINTENANCE_MESSAGES: readonly MaintenanceMessage[] = [
  { tone: 'friendly', text: 'Stiamo rimettendo qualche ingranaggio digitale al suo posto.' },
  { tone: 'friendly', text: 'Nexus sta facendo un piccolo pit stop tecnico. Grazie per l’attesa.' },
  { tone: 'friendly', text: 'Stiamo facendo ordine nel backstage digitale.' },
  { tone: 'friendly', text: 'Stiamo dando una sistemata a questa sezione di Nexus.', contexts: ['hub'] },
  { tone: 'geek', text: 'Qualche bit ha deciso di prendersi una pausa non autorizzata.' },
  { tone: 'geek', text: 'Stiamo riallineando qualche byte fuori posto.' },
  { tone: 'geek', text: 'Nexus sta negoziando la pace con alcuni processi ribelli.' },
  { tone: 'geek', text: 'Qualche ingranaggio digitale richiedeva una regolazione.' },
  { tone: 'geek', text: 'Stiamo convincendo alcuni processi a tornare al loro posto.' },
  { tone: 'geek', text: 'Stiamo rimettendo in fila qualche 1 e qualche 0.' },
  { tone: 'geek', text: 'Controlliamo che tutti i pixel siano dove dovrebbero essere.' },
  { tone: 'geek', text: 'Un paio di processi stanno ancora mettendosi d’accordo.' },
];

export function getRandomMaintenanceMessage(
  context: MaintenanceMessageContext,
  random: () => number = Math.random,
): string | null {
  const eligibleMessages = MAINTENANCE_MESSAGES.filter((message) => !message.contexts || message.contexts.includes(context));
  if (!eligibleMessages.length) return null;
  const sample = random();
  const index = Number.isFinite(sample)
    ? Math.min(Math.max(Math.floor(sample * eligibleMessages.length), 0), eligibleMessages.length - 1)
    : 0;
  return eligibleMessages[index].text;
}
